function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #959595;\n      }\n    "));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "motor",
  transform: "translate(-191.115 -325.932)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Grupo_75",
  "data-name": "Grupo 75",
  transform: "translate(208.49 334.11)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Grupo_74",
  "data-name": "Grupo 74"
}, /*#__PURE__*/React.createElement("path", {
  id: "Trazado_37",
  "data-name": "Trazado 37",
  className: "cls-1",
  d: "M210.917,335.323v6.932l9.441,4.721a.894.894,0,0,0,1.294-.8v-9.511Z",
  transform: "translate(-210.917 -335.323)"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Grupo_77",
  "data-name": "Grupo 77",
  transform: "translate(205.968 336.802)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Grupo_76",
  "data-name": "Grupo 76"
}, /*#__PURE__*/React.createElement("path", {
  id: "Trazado_38",
  "data-name": "Trazado 38",
  className: "cls-1",
  d: "M208.344,338.02a.894.894,0,0,0-1.006.887v4.025a.889.889,0,0,0,.495.8l1.294.647v-6.261Z",
  transform: "translate(-207.338 -338.015)"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Grupo_79",
  "data-name": "Grupo 79",
  transform: "translate(191.115 325.932)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Grupo_78",
  "data-name": "Grupo 78"
}, /*#__PURE__*/React.createElement("path", {
  id: "Trazado_39",
  "data-name": "Trazado 39",
  className: "cls-1",
  d: "M204.4,342.311v-3.705a2.472,2.472,0,0,1,2.776-2.451l11.922,1.491a14.1,14.1,0,0,0-5.993-9.27,14.646,14.646,0,0,0-12.008-1.916c-5.471,1.5-9.978,7.624-9.978,13.511v3.944a2.486,2.486,0,0,0,1.474,2.26l18.18,7.5a4.743,4.743,0,0,0,6.237-2.658c.086-.218.179-.492.27-.735l-11.514-5.76A2.47,2.47,0,0,1,204.4,342.311Zm-6.641,1.841a3.294,3.294,0,1,1,3.293-3.294A3.3,3.3,0,0,1,197.756,344.152Z",
  transform: "translate(-191.115 -325.932)"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Grupo_81",
  "data-name": "Grupo 81",
  transform: "translate(196.054 338.195)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Grupo_80",
  "data-name": "Grupo 80"
}, /*#__PURE__*/React.createElement("path", {
  id: "Trazado_40",
  "data-name": "Trazado 40",
  className: "cls-1",
  d: "M198.332,339.408a1.79,1.79,0,1,0,1.789,1.789A1.792,1.792,0,0,0,198.332,339.408Z",
  transform: "translate(-196.543 -339.408)"
}))));

function SvgMotor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.11,
    height: 28.104,
    viewBox: "0 0 28.11 28.104",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMotor);
export default __webpack_public_path__ + "static/media/motor.fb80c0ba.svg";
export { ForwardRef as ReactComponent };